<template>  


      <div class="col-12">
          <div class="card border-0">
            <div class="card-header font-weight-bold bg-transparent border-0">Create an Include</div>
            <div class="card-body pt-0">

              <div class="row">

                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-12">
                      <small class="">Item to Add</small>
                    </div>
                    <div class="form-group col-12 mb-3">
                     
                      <v-select 
                      v-model="itemID"
                     
                      placeholder="Select Item"
                      label="item_data"

                      :options= "allItemList"

                      :reduce="allItemList => allItemList.id"
                      class="p-0 bg-white style-chooser">

                      </v-select>

                    </div>
                      
                  </div>
                  
                </div>
              </div>
            

              <div class="row">
                <div class="col-12">
                  <button @click="cancelCreate" class="btn btn-danger">Cancel</button>
                  <button @click="submitForm" class="btn btn-success ml-2" >Save Item</button>
                </div>
              </div>
            </div><!--  end card-body -->
          </div><!--  end card -->
      </div>
      


</template>


<script>
import {store} from '../../../stores/admin-product-single-main-store.js'




export default {
  props: ['prop1'],
  store,
  data: function () {
    return { 
      itemID: '',
    }
  },
  computed: {
    detailsList () { return this.$store.state.detailsList },
    detailsComp () { return this.$store.state.detailsComp },
    itemList () { return this.$store.state.productItemList },
    allItemList () { return this.$store.state.itemList },
  },
  watch: {
    
  },
  mounted() {
    this.allItemList.map(function (x){
      return x.item_data = x.part_number + ' - ' + x.name;
    });
  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    
    validateForm() {
      var _this = this;
      var valErrors = [];

      if(_this.itemID == '' || _this.itemID == null || _this.itemID == 'n' ){ valErrors.push("A Valid Item must be selected!")  } 

      _this.itemList.forEach(myFunction);
      function myFunction(item, index) {
        if(_this.itemID == item.id) { valErrors.push("An item cannot be added twice, this item is already part of this product!")  } 
      }

      if( valErrors.length > 0) {
        _this.errorDisplay(valErrors);
        return false;
      } else {
        return true;
      }
    },
    submitForm() {
      var _this = this;
      var a = _this.validateForm();
      if(a == false) {
        return false;
      }
      _this.$toastr.warning('Saving product item.', 'Please wait!')
      axios.get( '/admin/utility/product/item/createrel/'+ _this.detailsList.id +'/' + _this.itemID)
      .then(function(response){
        var msg = response.data.msg;
        _this.$toastr.remove()
        _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
        _this.$emit('onSComplete', ['create-item']);
      }) //end then
      .catch(function (error) {
        var errors = error.response.data.errors;
        _this.errorDisplay(errors);
      })
    },

    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },

    cancelCreate() {
      var _this = this;
      _this.$emit('onUComplete', [ 'create-item' ])
    },


  },    
  components:{

    
  },
  filters: {

  }
}
</script>
